import { render, staticRenderFns } from "./insuredDetail.vue?vue&type=template&id=7d509224&scoped=true"
import script from "./insuredDetail.vue?vue&type=script&lang=js"
export * from "./insuredDetail.vue?vue&type=script&lang=js"
import style0 from "./insuredDetail.vue?vue&type=style&index=0&id=7d509224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d509224",
  null
  
)

export default component.exports